import EN from './EN.svg?raw'
import DA from './DA.svg?raw'
import DE from './DE.svg?raw'
import ES from './ES.svg?raw'
import FR from './FR.svg?raw'
import IT from './IT.svg?raw'
import JA from './JA.svg?raw'
import KO from './KO.svg?raw'
import ZH from './ZH.svg?raw'

function stripCircleMask(svg: string): string {
    return svg
        .replace(/<mask\b[^>]*>[\s\S]*?<\/mask>/g, '')
        .replace(/\s*mask="url\(#[^)]+\)"/g, '')
}

const raw: Record<string, string> = { DE, DA, EN, ES, FR, IT, JA, KO, ZH }

export const Flags: Record<string, string> = Object.fromEntries(
    Object.entries(raw).map(([code, svg]) => [code, stripCircleMask(svg)])
)
